module.exports = __webpack_public_path__ + "img/printer-gray.66a7200c.svg";